import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Project } from '../../portal/model/project';

@Injectable({
  providedIn: 'root'
})
export class ProjectdeleteService {

  serviceUrl:string = environment.apiUrl+'/organization/';
  constructor(private http:HttpClient) { }


  deleteProject(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(this.serviceUrl+SessionHelper.getChoosenOrg()+'/organizationproject/'+project.projectId,httpOptions)
  }
}
